/* Onglets accessibles : flèches, Début, Fin, comme le prévoit la norme ARIA. */
(function () {
  function brancher(box) {
    if (box.dataset.mcPret === '1') return;
    box.dataset.mcPret = '1';
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(box.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length) return;

    function activer(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) { panels[j].hidden = !on; panels[j].classList.toggle('is-on', on); }
      });
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activer(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); activer(n, true); }
      });
    });
  }
  function init(r) { (r || document).querySelectorAll('[data-mc-onglets]').forEach(brancher); }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  init();
})();
